import { RootStateOrAny, useSelector } from 'react-redux';

import { toStringSet } from '../../utils/assets';
import { getLineItems } from '../../utils/selectors';

function getUpsellProduct({ upsellAssets, products, isBorderfreeCustomer }) {
  if (upsellAssets?.data?.assets && upsellAssets?.data?.assets?.length) {
    // the api is returning the promo is the h2l of priority order
    // and it's also only returning corresponding assets based on user segements
    // so the first promo in asset array should always be the best promo (promo with highest priority)
    const bestPromo = upsellAssets?.data.assets[0];
    const { fplId, flags, numProducts, numPerOrder } =
      bestPromo.options.customVars;
    const promoProducts = products.filter(
      product =>
        product.fplIds &&
        product.fplIds.length &&
        product.fplIds.includes(fplId)
    );
    // display the upsell promo bundle when
    // 1. in the mini cart - from Cart Drawer
    // 2. is a bundle promo - checking formattedflags
    // 3. the product has the asset fplId - promoProducts
    // 4. the product starts a new set of promo bundle - promoStartProduct
    // 5. won't be showing promo with 'noBorderFree' flag for border free customer
    if (promoProducts.length && flags) {
      const formattedflags = toStringSet(
        bestPromo.options.customVars.flags,
        true
      );

      if (formattedflags.has('noborderfree') && isBorderfreeCustomer) {
        return null;
      }

      const remainder = promoProducts.length % numProducts;
      const promoStartProduct = remainder
        ? promoProducts[promoProducts.length - remainder]
        : null;

      if (
        formattedflags.has('bundle') &&
        promoProducts.length / numProducts < numPerOrder
      ) {
        return promoStartProduct;
      }
    }
  }
  return null;
}

export function useUpsellAssets() {
  const assets = useSelector(({ assets }: RootStateOrAny) => assets);
  const products = useSelector(getLineItems);
  const isBorderfreeCustomer = useSelector(
    ({ borderfree }: RootStateOrAny) => borderfree.isBorderfreeCustomer
  );
  const upsellAssets = assets?.containers?.upsell_html_minicart;
  if (!upsellAssets || !upsellAssets.data) {
    return { upsellAssetToTrack: null, upsellProduct: null };
  }
  const upsellAssetToTrack =
    assets?.containers?.upsell_html_minicart?.data?.assets?.[0];
  const upsellProduct = getUpsellProduct({
    upsellAssets,
    products,
    isBorderfreeCustomer,
  });

  return {
    upsellAssetToTrack,
    upsellProduct,
  };
}
